import { useCallback, useRef, useState } from 'react'

export function useConditionallyLoadMoreItems({
  loadMoreItems,
}: {
  loadMoreItems: (() => Promise<void> | void) | undefined
}) {
  // Ref is for instant double API call protection
  const isLoadingMoreItemsRef = useRef(false)

  // State is for a rerender triggering value to expose
  const [isLoadingMoreItems, setIsLoadingMoreItems] = useState(isLoadingMoreItemsRef.current)

  const conditionallyLoadMoreItems = useCallback(async () => {
    if (loadMoreItems && !isLoadingMoreItemsRef.current) {
      isLoadingMoreItemsRef.current = true
      setIsLoadingMoreItems(true)
      try {
        await loadMoreItems()
      } finally {
        isLoadingMoreItemsRef.current = false
        setIsLoadingMoreItems(false)
      }
    } else {
      await Promise.resolve()
    }
  }, [loadMoreItems])

  return {
    conditionallyLoadMoreItems,
    isLoadingMoreItems,
  }
}
